import React, { Component } from 'react';
import { func, string, object } from 'prop-types';
import Grid from '@material-ui/core/Grid';
// import './../ButtonCont/ButtonIconStylesCG.css';
import './cliente.css';
//import './../Componets/styles.css';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../../Actions/Dashboard';

class ButtonBoxIcon extends Component {

    pinchar = () => {        
        this.props.actions.selectFilter({ id: this.props.id, value: this.props.value }, this.props.group)
    };

    // btnTimeSelectionOn
    getClass = () => {
        for (let i = 0; i < this.props.filterArray.length; i++) {
            if (this.props.filterArray[i].name === this.props.group) {
                if (this.props.filterArray[i].value === this.props.value && this.props.filterArray[i].id === this.props.id)
                    return 'btnTimeSelectionOn'
            }
        }
        return 'btnTimeSelectionOff'
    }

    render() {
        const { value } = this.props;
        return (
            //Propiedades del boton usado en los componentes internos
            <Grid className={this.props.className}>
                <Grid>
                    <button
                        className={this.getClass(value)}
                        onClick={this.pinchar} >
                        <Grid>
                            {value}
                        </Grid>
                    </button>
                </Grid>
            </Grid>
        )
    }

}
//Verificacion de variables enviadas mediante props
ButtonBoxIcon.propTypes = {
    title: string,
    icon: object,
    onButtonBoxClick: func,
}

function mapStateToProps(state) {
    return {
        filterArray: state.dashboard.filterArray
    }
}

function mapDispathToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    }
}
export default connect(mapStateToProps, mapDispathToProps)(ButtonBoxIcon);
